import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

import actions from '../../../../actions';

export function section({ channel, preview, shopId }) {
  const value = preview.get(ATTRIBUTE.SECTION);
  const index = preview.get('index');
  const payload = Map({ type: OPERATIONS[channel].SECTION, value: value || 'none' });
  const actionsToDispatch = [];

  if (value && index === -1) {
    actionsToDispatch.push(actions.data.addSection({ shopId, section: value }));
  }

  return { actions: actionsToDispatch, payload };
}
